jQuery(document).ready(function ($) {
  // Code that uses jQuery's $ can follow here.
  let
    body = $('body'),
    m_container = $('.mobile-menu'),
    s_container = $('#search-container')

  $('.menu-toggle').on('click', function () {
    let
      wrapper = m_container

    wrapper.toggleClass('menu-open')
    body.toggleClass('mabile-menu-opened')
  })

  $('.menu-close').on('click', function () {
    var
      wrapper = m_container

    wrapper.toggleClass('menu-open')
    body.toggleClass('mabile-menu-opened')
  })

  // Search toggle.
  $('.search-toggle').on('click', function (event) {

    let
      wrapper = s_container

    wrapper.toggleClass('search-open')
    body.toggleClass('mabile-menu-opened')

    if (wrapper.is('.search-open') || $('.search-toggle .screen-reader-text')[0] === event.target) {
      setTimeout(function () {
        wrapper.find('.search-field').focus()
      }, 100)
    }
  })

  $('.search-close').on('click', function () {
    var
      wrapper = s_container

    wrapper.toggleClass('search-open')
    body.toggleClass('mabile-menu-opened')
  })

  $('body').on('click', '.top', function () {
    $('html, body').animate({ scrollTop: 0 }, 300)
  })

  $('body').append('<div class="top"><i class="ico-up">')

  $(window).scroll(function () {
    if ($(window).scrollTop() > $(window).height() / 2) {
      $('.top').addClass('active')
    } else {
      $('.top').removeClass('active')
    }
  })

  $(window).scroll(function () {
    if ($(window).scrollTop() > ($(".site-header").height() + 2)) {
      $('.site-header').addClass('inactive')
    } else {
      $('.site-header').removeClass('inactive')
    }
    if ($(window).scrollTop() > ($('.site-header').height() + 14)) {
      $('.site-header').addClass('active')
      $('.fixed-wrap').addClass('container-xxl')
    } else {
      $('.site-header').removeClass('active')
      $('.fixed-wrap').removeClass('container-xxl')
    }
  })

})
